<template>
  <div class="benefit-page">
    <!-- Loading State -->
    <bert-loading 
      v-if="isLoading" 
      :fullscreen="true" 
      size="lg" 
      text="Loading Benefit BERT Points..."
    />

    <!-- Main Content -->
    <div v-else class="page-content">
      <!-- Header -->
      <AppHeader />

      <!-- Points Types Section -->
      <section class="points-types-section">
        <div class="section-container">
          <div class="points-grid">
            <div class="points-intro">
              <h2 class="intro-title">Reward Points<br>dan Award Points</h2>
              <p class="intro-description">
                Bert Points terdiri dari 2 jenis Points,<br>
                yaitu Reward Points & Award Points
              </p>
            </div>
            <div class="point-card reward">
              <div class="point-icon-wrapper">
                <img src="@/assets/berts-point-reward.svg" alt="Point Reward" />
              </div>
              <div class="card-content">
                <div class="card-header">
                  <h3 class="point-title">Reward Points</h3>
                </div>
                <div class="card-body">
                  <p class="point-description">
                    Points yang didapat jika mendaftar 
                    di website ini sebagai anggota dari 
                    salah satu BERT's community, 
                    yaitu Ibu2Canggih, Geng Glowing 
                    atau Ikan Galau.
                  </p>
                </div>
              </div>
            </div>
            
            <div class="point-card award">
              <div class="point-icon-wrapper">
                <img src="@/assets/berts-point-award.svg" alt="Point Award" />
              </div>
              <div class="card-content">
                <div class="card-header">
                  <h3 class="point-title">Award Points</h3>
                </div>
                <div class="card-body">
                  <p class="point-description">
                    Points yang didapat jika mendaftar 
                    di website ini sebagai BERT's 
                    Influencer, termasuk Momfluencer, 
                    Creators maupun Glowfluencer.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Pointers of the Month Section -->
      <section class="pointers-section" v-if="currentPointer">
        <div class="section-container">
          <div class="section-header">
            <h2 class="section-title">Pointers of the Month</h2>
            <p class="section-subtitle">
              Peringkat tertinggi perolehan BERT's Point bulan ini,<br>
              kumpulkan point dan jadilah yang terbaik di bulan berikutnya!
            </p>
          </div>
          
          <div class="pointers-bg">
            <div class="pointers-showcase">
              <div class="pointer-card featured">
                <div class="pointer-image-header">
                  <img :src="getDisplayImage(currentPointer)" :alt="currentPointer.user_name" class="pointer-photo" />
                  <div class="winner-badge">
                    <i class="mdi mdi-crown"></i>
                    Winner
                  </div>
                </div>
                
                <div class="pointer-info">
                  <h3 class="pointer-name">{{ currentPointer.user_name }}</h3>
                  <div class="pointer-stats">
                    <div class="stat-item">
                      <span class="stat-label">Total Points</span>
                      <span class="stat-value">{{ formatPoints(currentPointer.user_points || 0) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- No Active Pointer -->
      <section class="no-pointer-section" v-else-if="!isLoading">
        <div class="section-container">
          <div class="section-header">
            <h2 class="section-title">Pointers of the Month</h2>
          </div>
          <div class="no-pointer-content">
            <div class="no-pointer-icon">
              <i class="mdi mdi-trophy-outline"></i>
            </div>
            <h3>Belum Ada Pointer Bulan Ini</h3>
            <p>Pointer of the Month untuk bulan ini belum ditentukan. Tetap kumpulkan BERT's Point untuk kesempatan menjadi pemenang bulan depan!</p>
          </div>
        </div>
      </section>

      <!-- Benefits Section -->
      <section class="benefits-section">
        <div class="section-container">
          <div class="section-header">
            <h2 class="section-title">Manfaat Mengumpulkan Bert Points</h2>
          </div>
          
          <div class="benefits-grid">
            <div class="benefit-item">
              <div class="benefit-image">
                <img src="@/assets/bert-benefit-1.jpg" alt="Kolaborasi dengan brands" class="benefit-photo" />
              </div>
              <div class="benefit-content">
                <div class="benefit-icon">
                  <img src="@/assets/benefit-logo-1.svg" alt="Benefit 1" class="benefit-photo" />
                </div>
                <p class="benefit-text">
                  Dapat kesempatan 
                  berkolaborasi dengan banyak 
                  brands ternama
                </p>
              </div>
            </div>
            
            <div class="benefit-item">
              <div class="benefit-image">
                <img src="@/assets/bert-benefit-2.jpg" alt="Koneksi dan sharing" class="benefit-photo" />
              </div>
              <div class="benefit-content">
                <div class="benefit-icon">
                  <img src="@/assets/benefit-logo-3.svg" alt="Benefit 1" class="benefit-photo" />
                </div>
                <p class="benefit-text">
                  Membangun koneksi dan bisa 
                  sharing dengan sesama 
                  member.
                </p>
              </div>
            </div>
            
            <div class="benefit-item">
              <div class="benefit-image">
                <img src="@/assets/bert-benefit-3.png" alt="Hadiah eksklusif" class="benefit-photo" />
              </div>
              <div class="benefit-content">
                <div class="benefit-icon">
                  <img src="@/assets/benefit-logo-4.svg" alt="Benefit 1" class="benefit-photo" />
                </div>
                <p class="benefit-text">
                  Mendapatkan beragam hadiah 
                  yang bisa diklaim lewat jumlah 
                  Points
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Rewards Claim Section -->
      <section class="rewards-claim-section">
        <div class="section-container">
          <div class="rewards-content">
            <div class="rewards-text">
              <h2 class="rewards-title">
                Kumpulkan Reward Points<br>
                dan Klaim Hadiahnya!
              </h2>
              <bert-button variant="primary" size="lg" class="claim-button" @click="goToLogin">
                Klaim Sekarang
              </bert-button>
            </div>
            <div class="rewards-visual">
              <img src="@/assets/⁠kumpulkan-reward.jpg" alt="Rewards Dashboard" class="rewards-image" />
            </div>
          </div>
        </div>
      </section>

      <!-- Campaign Section -->
      <section class="campaign-section">
        <div class="section-container">
          <div class="campaign-content">
            <div class="rewards-visual">
              <img src="@/assets/ikuti-beragam.jpg" alt="Rewards Dashboard" class="rewards-image" />
            </div>
            <div class="campaign-text">
              <h2 class="campaign-title">
                Ikuti Beragam Campaigns<br>
                dengan Brand, Dapatkan<br>
                Award Points, dan Hadiah<br>
                Eksklusif!
              </h2>
              <bert-button variant="primary" size="lg" class="campaign-button"  @click="goToRegister">
                Daftar Sekarang
              </bert-button>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA Section -->
      <section class="cta-section">
        <div class="cta-container">
          <div class="cta-content">
            <h2 class="cta-title">Tertarik Untuk Bekerja Sama?</h2>
            <bert-button variant="outline" size="lg" class="cta-button" @click="contactUs('Halo Admin, saya berminat untuk daftar jadi Brand Partner. Bagaimana caranya?')">
              Klik Disini!
            </bert-button>
          </div>
        </div>
      </section>

      <section class="empty-section">

      </section>

      <!-- Footer -->
      <AppFooter />
    </div>
  </div>
</template>

<script>
import BertButton from './ui/Button.vue'
import BertLoading from './ui/Loading.vue'
import Header from './layout/Header.vue'
import Footer from './layout/Footer.vue'

export default {
  name: 'BenefitBertPoints',
  components: {
    BertButton,
    BertLoading,
    AppHeader: Header,
    AppFooter: Footer
  },
  data() {
    return {
      isLoading: false,
      currentPointer: null,
    }
  },
  methods: {
    loading() {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    },
    goToLogin() {
      this.$router.push('/login')
    },
    goToRegister() {
      this.$router.push('/login')
    },
    contactUs(message) {
      const phoneNumber = "628115674433"; 
      const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
      window.location.href = url;
    },
    fetchCurrentPointer() {
      const baseURI = this.$settings.endPoint + "pointers-of-month/public";
      
      return this.$http
        .get(baseURI, { 
          timeout: 10000,
          headers: {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          if (response.data.status === 200) {
            this.currentPointer = response.data.datas.current_pointer;
            this.topUsers = response.data.datas.recent_pointers || [];
          }
        })
        .catch((error) => {
          console.error("Error fetching pointers data:", error);
        });
    },

    getDisplayImage(pointer) {
      if (pointer.custom_image) {
        return pointer.custom_image;
      }
      return this.getUserImageFromSnapshot(pointer);
    },

    getUserImage(user) {
      if (user?.image) {
        return user.image;
      }
      return require('@/assets/maternity.png');
    },

    formatPoints(points) {
      if (!points) return '0';
      return new Intl.NumberFormat('id-ID').format(points);
    },

    getUserImageFromSnapshot(pointer) {
      if (pointer?.user_image) {
        return pointer.user_image;
      }
      return require('@/assets/maternity.png');
    },

    formatMonthYear(monthYear) {
      if (!monthYear) return '';
      const date = new Date(monthYear + '-01');
      return date.toLocaleDateString('id-ID', { 
        year: 'numeric', 
        month: 'long' 
      });
    },

    getRankClass(index) {
      if (index === 0) return 'rank-gold';
      if (index === 1) return 'rank-silver';
      if (index === 2) return 'rank-bronze';
      return 'rank-default';
    },

    getRankIcon(index) {
      if (index === 0) return 'mdi mdi-trophy';
      if (index === 1) return 'mdi mdi-medal';
      if (index === 2) return 'mdi mdi-medal-outline';
      return '';
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    }
  },
  mounted() {
    this.isLoading = true;
    
    this.fetchCurrentPointer().finally(() => {
      this.isLoading = false;
    });
  }
}
</script>

<style scoped>

.winner-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.3);
}

.winner-badge i {
  font-size: 16px;
}

.pointer-stats {
  display: flex;
  gap: 24px;
  margin: 16px 0;
  justify-content: center;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.stat-label {
  font-size: 12px;
  color: var(--text-dark-grey);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-dark);
}

.stat-value.active {
  color: #10B981;
}

.benefit-page {
  min-height: 100vh;
  background: #F5F5F5;
}

.page-content {
  width: 100%;
}

/* Points Types Section */
.points-types-section {
  padding: var(--space-20) 0;
  background: white;
}

.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
}

.points-intro {
  align-content: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.intro-title {
  font-size: var(--text-4xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0 0 var(--space-6) 0;
  line-height: 1.2;
}

.intro-description {
  font-size: var(--text-lg);
  color: var(--text-dark-grey);
  margin: 0;
  line-height: 1.6;
}

/* Grid Layout */
.points-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 2 Columns */
  gap: var(--space-12);
  align-items: stretch; /* Ensures cards are same height */
}

/* Card Styling */
.point-card {
  background: white;
  border-radius: var(--radius-xl);
  text-align: center;
  border: 1px solid #E5E5E5; /* Subtle border */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05); /* Soft shadow */
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
}

/* Hover Effects */
.point-card:hover {
  transform: translateY(-8px); /* Lift up effect */
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
}

.card-header {
  padding: 24px;
  background-color: white;
}

.point-icon-wrapper {
  margin-bottom: var(--space-6);
  margin-top: var(--space-6);
  display: flex;
  justify-content: center;
  transition: transform 0.3s ease;
}

.point-card:hover .point-icon-wrapper {
  transform: scale(1.1); /* Icon pops slightly on hover */
}

.point-title {
  font-size: var(--text-2xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0;
}

.card-body {
  flex-grow: 1; /* Pushes content to fill space */
}

.point-description {
  font-size: var(--text-base);
  color: var(--text-dark-grey);
  line-height: 1.8;
  margin: 0;
}

/* Pointers Section */
.pointers-section {
  padding: var(--space-20) 0;
  background: white;
}

.section-header {
  text-align: center;
  margin-bottom: var(--space-12);
}

.section-title {
  font-size: var(--text-5xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0 0 var(--space-4) 0;
}

.section-subtitle {
  font-size: var(--text-lg);
  color: var(--text-dark-grey);
  margin: 0;
  line-height: 1.6;
}

.pointers-showcase {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  gap: var(--space-12);
  transform: translateY(-60px);
}

.pointer-card {
  background: white;
  border-radius: 24px;
  padding: 0; 
  text-align: center;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08), 0 4px 8px rgba(0,0,0,0.02);
  max-width: 320px;
  width: 100%;
  transition: all 0.4s ease;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.pointer-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.12);
}

.pointer-image-header {
  width: 100%;
  height: 220px;
  background-color: #f0f0f0;
  position: relative;
}

.pointer-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  border-radius: 0;
  border: none;
  display: block;
}

/* Content Container */
.pointer-info {
  padding: 24px; /* Padding moves here */
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  flex-grow: 1;
}

.pointer-name {
  font-size: var(--text-2xl);
  font-weight: 800;
  color: var(--text-dark);
  margin: 0;
}

.pointer-community {
  font-size: var(--text-base);
  color: var(--text-dark-grey);
  margin-bottom: var(--space-4);
}

.pointer-points {
  font-weight: var(--font-semibold);
}

.pointers-bg {
  position: relative;
  margin-top: var(--space-20);
  padding-bottom: var(--space-20);
}

.pointers-bg::before {
  content: "";
  position: absolute;
  top: 80px;               /* ← pushes yellow down */
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--yellow-main);
  border-radius: var(--radius-3xl);
  z-index: 0;
}

/* No Pointer Section */
.no-pointer-section {
  padding: var(--space-20) 0;
  background: white;
}

.no-pointer-section .section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--space-12);
  border-radius: var(--space-12);
  background-color: white;
}

.no-pointer-section .section-header {
  text-align: center;
  margin-bottom: var(--space-8);
}

.no-pointer-content {
  text-align: center;
  padding: var(--space-16);
  background: #F9FAFB;
  border-radius: var(--radius-2xl);
  border: 2px dashed #E5E7EB;
}

.no-pointer-icon {
  font-size: 80px;
  color: #D1D5DB;
  margin-bottom: var(--space-6);
}

.no-pointer-icon i {
  display: inline-block;
}

.no-pointer-content h3 {
  font-size: var(--text-2xl);
  font-weight: 700;
  color: var(--text-dark);
  margin: 0 0 var(--space-4) 0;
}

.no-pointer-content p {
  font-size: var(--text-base);
  color: var(--text-dark-grey);
  line-height: 1.6;
  max-width: 500px;
  margin: 0 auto;
}

/* Benefits Section */
.benefits-section {
  padding: var(--space-20) 0;
  background: var(--blue-soft);
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--space-8);
}

.benefit-item {
  text-align: center;
  background-color: white;
  padding: 8px 8px 36px 8px;
  border-radius: 12px;
  box-shadow: var(--shadow-md);
  overflow: hidden; /* Ensures image corners obey border radius */
}

.benefit-image {
  margin-bottom: var(--space-6);
  border-radius: var(--radius-xl);
  overflow: hidden;
  width: 100%;
  height: 200px; /* Fixed height for consistency */
}

/* Specific styling for the Main Benefit Image */
.benefit-image .benefit-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.benefit-content {
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--space-4);
}

.benefit-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Specific styling for the Icon */
.benefit-icon .benefit-photo {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.benefit-text {
  font-size: var(--text-base);
  color: var(--text-dark-grey);
  line-height: 1.6;
  margin: 0;
  text-align: start;
}

/* Rewards Claim Section */
.rewards-claim-section {
  padding: var(--space-20) 0;
  background: white;
}

.rewards-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-16);
  align-items: center;
}

.rewards-title {
  font-size: var(--text-4xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0 0 var(--space-8) 0;
  line-height: 1.2;
}

.claim-button {
  background: var(--yellow-main);
  border: none;
  color: white;
}

.rewards-visual {
  display: flex;
  justify-content: center;
  width: 610px;
  height: 386px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.rewards-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* Campaign Section */
.campaign-section {
  padding: var(--space-20) 0;
  background: white;
}

.campaign-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-16);
  align-items: center;
}

.campaign-image {
  border-radius: var(--radius-xl);
  overflow: hidden;
  box-shadow: var(--shadow-lg);
}

.campaign-photo {
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.campaign-title {
  font-size: var(--text-3xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0 0 var(--space-8) 0;
  line-height: 1.2;
}

.campaign-button {
  background: var(--yellow-main);
  border: none;
  color: white;
}

/* CTA Section */
.cta-section {
  padding: 40px 20px;
  background-color: white; /* Space around the card */
}

.cta-container {
  max-width: 1100px;
  margin: 0 auto;
  /* Apply background image here */
  background: #F9A619 url('~@/assets/cta-background.png') no-repeat center center;
  background-size: cover;
  border-radius: 20px; /* Rounded corners for the card */
  padding: 60px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-shadow: 0 10px 30px rgba(249, 166, 25, 0.2);
}

.cta-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.cta-title {
  color: #2B2F3C;
  font-size: 32px;
  font-weight: 800;
  margin: 0;
  line-height: 1.2;
}

/* Style for the button to make it pop against the orange */
.cta-button {
  background-color: white !important;
  color: #2B2F3C !important;
  border-radius: 50px;
  padding: 12px 40px;
  font-weight: 700;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
}

.empty-section {
  height: 120px;
  background-color: white;
}


/* Responsive Design */
@media (max-width: 768px) {

  .no-pointer-section {
    padding: var(--space-8) 0;
  }

  .no-pointer-section .section-container {
    padding: var(--space-4);
  }

  .no-pointer-content {
    padding: var(--space-8);
  }

  .no-pointer-icon {
    font-size: 60px;
  }

  .no-pointer-content h3 {
    font-size: var(--text-xl);
  }

  .no-pointer-content p {
    font-size: var(--text-sm);
  }

  .campaign-section {
    padding: var(--space-8) 0;
  }
  .section-container {
    padding: 0 var(--space-4);
  }
  
  .intro-title,
  .section-title {
    font-size: var(--text-3xl);
    text-align: center;
  }
  
  .intro-description,
  .section-subtitle {
    font-size: var(--text-base);
    text-align: center;
  }
  
  /* Point Types Mobile */
  .points-grid {
    grid-template-columns: 1fr;
    gap: var(--space-8);
  }
  
  .point-card {
    padding: var(--space-6);
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: var(--space-4);
    text-align: left;
  }

  .point-icon-wrapper {
    margin-bottom: 0;
    flex-shrink: 0;
    margin: 0;
    align-self: center;
  }

  .point-icon-wrapper img {
    width: 60px;
    height: 60px;
  }

  .card-content {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .card-header {
    padding: 0;
    margin-bottom: var(--space-3);
  }

  .point-title {
    font-size: var(--text-xl);
    margin: 0;
  }

  .card-body {
    text-align: left;
    padding: 0;
  }

  .point-description {
    margin: 0;
  }

  .points-types-section {
    padding: var(--space-8) 0;
  }
  
  /* Pointers Mobile Fix */
  .pointers-bg::before {
    top: 60px;
    border-radius: var(--radius-2xl);
  }

  .pointers-showcase {
    flex-direction: row; /* Force row layout */
    align-items: flex-start;
    justify-content: center;
    gap: var(--space-3);
    padding: 0 var(--space-2);
    transform: translateY(10px);
  }

  .pointer-card {
    max-width: 200px;
    width: 50%;
    flex: 1;
  }

  .pointer-image-header {
    height: 120px;
  }

  .pointer-photo {
    height: 120px;
  }

  .pointer-info {
    padding: var(--space-3);
  }

  .pointer-name {
    font-size: 14px;
  }

  .pointer-community {
    font-size: 11px;
    margin-bottom: 4px;
    line-height: 1.2;
  }

  .pointer-points {
    font-size: 10px;
  }
  
  /* Benefits Mobile Fix */
  .benefits-grid {
    grid-template-columns: 1fr;
    gap: var(--space-6);
  }

  .benefit-item {
     padding-bottom: 24px;
  }

  .benefit-content {
    padding-left: 16px;
    padding-right: 16px;
  }
  
  /* Main Image Mobile Size */
  .benefit-image {
    height: 160px; /* Consistent height for mobile */
    margin-bottom: var(--space-4);
  }
  
  .benefit-image .benefit-photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  
  /* Icon Mobile Size */
  .benefit-icon .benefit-photo {
    width: 40px; /* Smaller icon size */
    height: 40px;
    object-fit: contain;
  }
  
  .benefit-text {
    font-size: 14px;
  }
  
  /* Rewards & Campaigns */
  .rewards-content,
  .campaign-content {
    grid-template-columns: 1fr;
    gap: var(--space-6);
    text-align: center;
  }

  .rewards-visual,
  .campaign-visual {
    order: -1;
    width: 100%;
    height: 250px;
    max-width: 100%;
  }

  .rewards-title,
  .campaign-title {
    font-size: var(--text-2xl);
    text-align: center;
  }

  .rewards-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .campaign-photo {
    height: 250px;
  }
  
  .cta-title {
    font-size: var(--text-2xl);
  }
}

@media (max-width: 480px) {
  .pointers-bg::before {
    top: 100px;
  }
}
</style>